module.exports = __webpack_public_path__ + "static/mockup-create-league-804db8698146424dea4a734f961c3d93.png";